<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    
    <!-- formulario -->
    <v-row>
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="loadingForm"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Usuario
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form 
                  ref="form" 
                  v-model="form"
                >
                  <v-select
                    outlined
                    multiple
                    small-chips
                    label="Perfil*"
                    :items="perfiles"
                    item-value="id"
                    item-text="perfil"
                    v-model="perfil"
                    :rules="perfilReglas"
                  >
                  </v-select>

                  <v-select
                    outlined
                    dense
                    label="Regional*"
                    :items="regionales"
                    item-value="id"
                    item-text="regional"
                    v-model="regional"
                    :rules="regionalReglas"
                  >
                  </v-select>

                  <v-select
                    outlined
                    dense
                    label="Centro de Formación*"
                    :items="centrosFormacion"
                    item-value="id"
                    item-text="centro_formacion"
                    v-model="centroFormacion"
                    :rules="centroFormacionReglas"
                  >
                  </v-select>

                  <v-text-field
                    outlined
                    dense
                    counter
                    type="number"
                    label="Número de Identificación*"
                    v-model.trim="identificacion"
                    :rules="identificacionReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Nombres*"
                    maxlength="50"
                    counter
                    v-model.trim="nombres"
                    :rules="nombresReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Apellidos*"
                    maxlength="50"
                    counter
                    v-model.trim="apellidos"
                    :rules="apellidosReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="number"
                    label="Teléfono*"
                    counter
                    v-model.trim="telefono"
                    :rules="telefonoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Correo Electrónico*"
                    maxlength="50"
                    counter
                    v-model.trim="correo"
                    :rules="correoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    disabled
                    type="text"
                    label="Contraseña"
                    v-model="identificacion"
                  >
                  </v-text-field>

                  <v-btn
                    block
                    large
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    perfil: [],
    perfilReglas: [
      (v) => (v && v.length > 0) || "Seleccione minimo un perfil"
    ],

    regional: '',
    regionalReglas: [
      v => !!v || "Seleccione una regional"
    ],

    centroFormacion: '',
    centroFormacionReglas: [
      v => !!v || "Seleccione un centro de formación"
    ],

    identificacion: '',
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (!v || v > 0) || "El número debe ser mayor a 0",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",      
      (v) => (v && v.length >= 6) || "Minimo 6 digitos"
    ],

    nombres: '',
    nombresReglas: [
      v => !!v || "Escriba nombres"
    ],

    apellidos: '',
    apellidosReglas: [
      v => !!v || "Escriba apellidos"
    ],

    telefono: '',
    telefonoReglas: [
      (v) => !!v || "Escriba un número de telefono",
      (v) => (!v || v > 0) || "El número debe ser mayor a 0",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    correo: '',
    correoReglas: [
      v => !!v || "Escriba un correo electrónico",
      v => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ]
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("gestionarPerfiles")
    this.$store.dispatch("crearRegionales")
    this.$store.dispatch("crearCentrosFormacion")
    this.$store.dispatch("editarUsuario", this.$route.params.id_usuario)
    .then((response) => {
      response.usuario_perfil.forEach(perfil => {
        this.perfil.push(perfil.perfil_id);
      });

      this.regional         = response.centro_formacion.regional_id;
      this.centroFormacion  = response.centro_formacion_id;
      this.identificacion   = response.identificacion;
      this.nombres          = response.nombres;
      this.apellidos        = response.apellidos;
      this.telefono         = response.telefono;
      this.correo           = response.correo;
    })
    .catch(() => {});
  },

  computed: {
    perfiles() {
      return this.$store.getters.obtenerPerfiles.filter(perfil => perfil.id > 1)
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    }
  },

  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const usuario = {
          id:                   this.$route.params.id_usuario,
          perfiles:             this.perfil,
          centro_formacion_id:  this.centroFormacion,
          identificacion:       this.identificacion,
          nombres:              this.nombres,
          apellidos:            this.apellidos,
          telefono:             this.telefono,
          correo:               this.correo,
          password:             this.identificacion
        }

        this.$store.dispatch("actualizarUsuario", usuario)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;
            let message       = response.message.split(',')

            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => (
              this.$router.replace({ name: 'usuario-gestionar' })
            ), 2000)
          }
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>